import { FC, forwardRef, InputHTMLAttributes } from 'react'
import { useRifm } from 'rifm'

import { InputProps as BaseInputProps, Input } from '@revolut-internal/ui-kit'

export type RifmArgs = {
  value: string
  mask?: boolean
  accept?: RegExp
  format: (str: string) => string
  replace?: (str: string) => string
  append?: (str: string) => string
  onChange: (str: string) => void
}
type InputProps = Omit<BaseInputProps, 'onChange'>

type InputWithRifmProps = InputProps & {
  options: Omit<RifmArgs, 'value' | 'onChange'>
  component?: FC<InputHTMLAttributes<HTMLInputElement>>
  onChange: (arg: string) => void
}

export const InputWithRifm: FC<InputWithRifmProps> = forwardRef(
  ({ value, component, options, onChange, ...props }, ref) => {
    const rifm = useRifm({
      value: value?.toString() || '',
      onChange,
      ...options,
    })

    const InputComponent = (component as FC<InputProps>) ?? Input

    return <InputComponent ref={ref} {...props} {...rifm} />
  },
)
